// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/problem_green.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../images/problem_gray.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SummaryMonitors_wrapper__oCK8X {
  background: linear-gradient(180deg, #ECFFFE 49.99%, #FFF 50%, #FFF 100%);
}
@media (max-width: 550px) {
  .SummaryMonitors_wrapper__oCK8X {
    padding: 22px 29px;
  }
}

.SummaryMonitors_title__ZBpF6 {
  color: #242424;
  font-size: 17px;
  font-weight: 600;
}

.SummaryMonitors_info_wrapper__an4Hu {
  display: flex;
  justify-content: space-between;
  height: 73px;
}
.SummaryMonitors_info_wrapper__an4Hu .SummaryMonitors_title__ZBpF6 {
  color: #000000;
  font-weight: 600;
  font-size: 13px;
}
@media (max-width: 550px) {
  .SummaryMonitors_info_wrapper__an4Hu {
    flex-direction: column;
    height: auto;
  }
}

.SummaryMonitors_availability_wrapper__jG-n4 {
  height: 100%;
}

.SummaryMonitors_availability__SbiVC {
  display: flex;
  align-items: flex-end;
  gap: 30px;
  font-size: 12px;
  color: #758282;
}
@media (max-width: 550px) {
  .SummaryMonitors_availability__SbiVC {
    gap: 15px;
  }
}

.SummaryMonitors_availability_block__Z1LVx {
  position: relative;
}
.SummaryMonitors_availability_block__Z1LVx::before {
  content: "";
  position: absolute;
  bottom: 3.5px;
  left: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.SummaryMonitors_availability_value__4PMT3 {
  font-size: 17px;
}
@media (max-width: 550px) {
  .SummaryMonitors_availability_value__4PMT3 {
    font-size: 15px;
  }
}
.SummaryMonitors_availability_value__large__xKfTI {
  font-weight: 600;
  font-size: 27px;
}
@media (max-width: 550px) {
  .SummaryMonitors_availability_value__large__xKfTI {
    font-size: 20px;
  }
}

.SummaryMonitors_availability_period__oYfRB {
  padding-left: 20px;
}

.SummaryMonitors_availability_high__QlHQD .SummaryMonitors_availability_value__4PMT3 {
  color: #00B86B;
}
.SummaryMonitors_availability_high__QlHQD::before {
  background-color: #00B86B;
}

.SummaryMonitors_availability_medium__oGnLn .SummaryMonitors_availability_value__4PMT3 {
  color: #FE974A;
}
.SummaryMonitors_availability_medium__oGnLn::before {
  background-color: #FE974A;
}

.SummaryMonitors_availability_low__24k4q .SummaryMonitors_availability_value__4PMT3 {
  color: #F44336;
}
.SummaryMonitors_availability_low__24k4q::before {
  background-color: #F44336;
}

.SummaryMonitors_monitors_wrapper__HikSE {
  display: flex;
  align-items: center;
  gap: 60px;
  position: relative;
  margin-bottom: 20px;
}

.SummaryMonitors_informer_icon__9sirz, .SummaryMonitors_informer_icon_problem__BCHQm {
  position: relative;
  z-index: 2;
}
.SummaryMonitors_informer_icon_problem__BCHQm {
  top: -10px;
}
@media (max-width: 550px) {
  .SummaryMonitors_informer_icon_problem__BCHQm {
    width: 120px !important;
    height: 120px !important;
    top: -5px;
    right: -10px;
  }
}
@media (max-width: 550px) {
  .SummaryMonitors_informer_icon__9sirz, .SummaryMonitors_informer_icon_problem__BCHQm {
    width: 150px;
    height: 150px;
  }
}

.SummaryMonitors_up__DNtFF {
  position: relative;
}
.SummaryMonitors_up_info__9WS\\+e {
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 18px;
  width: 136px;
  height: 136px;
  border-radius: 50%;
  background-color: #FFFFFF;
}
@media (max-width: 550px) {
  .SummaryMonitors_up_info__9WS\\+e {
    top: 10px;
  }
}
.SummaryMonitors_up_info__9WS\\+e .SummaryMonitors_counter__EEIqe {
  font-weight: 600;
  font-size: 37px;
  color: #000000;
}
@media (max-width: 550px) {
  .SummaryMonitors_up_info__9WS\\+e .SummaryMonitors_counter__EEIqe {
    font-size: 30px !important;
  }
}
.SummaryMonitors_up_info__9WS\\+e > p {
  color: #242424;
}

.SummaryMonitors_has_problems__3JKqG {
  position: absolute;
  right: 68px;
  top: 25%;
}
.SummaryMonitors_has_problems_info__sG2Xr {
  position: absolute;
  top: 10px;
  left: 7px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  width: 124px;
  height: 124px;
  border-radius: 50%;
  background-color: #FFFFFF;
}
@media (max-width: 550px) {
  .SummaryMonitors_has_problems_info__sG2Xr {
    top: -4px;
    left: 15px;
  }
}
.SummaryMonitors_has_problems_info__sG2Xr .SummaryMonitors_counter__EEIqe {
  font-weight: 600;
  font-size: 37px;
  color: #F44336;
}
@media (max-width: 550px) {
  .SummaryMonitors_has_problems_info__sG2Xr .SummaryMonitors_counter__EEIqe {
    font-size: 30px;
  }
}
.SummaryMonitors_has_problems_info__sG2Xr > p {
  color: #F44336;
}

.SummaryMonitors_no_problems__UUjH1 {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-color: #FFFFFF;
  border: solid 5px #758282;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 74px;
  top: 25%;
}
@media (max-width: 550px) {
  .SummaryMonitors_no_problems__UUjH1 {
    width: 114px;
    height: 114px;
    right: 64px;
  }
}
.SummaryMonitors_no_problems__UUjH1 > p {
  color: #758282;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
}

.SummaryMonitors_paused_wrapper__46MHR {
  position: relative;
  height: 100%;
  width: 120px;
}
@media (max-width: 550px) {
  .SummaryMonitors_paused_wrapper__46MHR {
    margin-top: 20px;
  }
}

.SummaryMonitors_paused_informer__sdoFB {
  position: absolute;
  right: 5px;
  bottom: 5px;
  border-radius: 30px;
  background: #616E6E;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 11px 6px 6px;
  gap: 6px;
}
@media (max-width: 550px) {
  .SummaryMonitors_paused_informer__sdoFB {
    font-size: 20px;
    left: 115px;
    right: unset;
    bottom: -10px;
  }
}

.SummaryMonitors_paused_value__48uFz {
  color: #FFF;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 17px;
}

.SummaryMonitors_problems_container__5Sc9t {
  width: 276px;
  height: 276px;
  position: absolute;
  right: 0;
  top: -56px;
  display: flex;
  z-index: 88;
}
@media (max-width: 550px) {
  .SummaryMonitors_problems_container__5Sc9t {
    width: 240px;
    height: 240px;
    top: -40px;
    right: -15%;
  }
}

.SummaryMonitors_problems_bg_green__MLS0z {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.SummaryMonitors_problems_bg_gray__DJ3hS {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}`, "",{"version":3,"sources":["webpack://./src/components/Home/SummaryMonitors/SummaryMonitors.module.scss"],"names":[],"mappings":"AAAA;EACE,wEAAA;AACF;AACE;EAHF;IAII,kBAAA;EAEF;AACF;;AACA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAEF;AAAE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AACE;EAXF;IAYI,sBAAA;IACA,YAAA;EAEF;AACF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAEF;AAAE;EAPF;IAQI,SAAA;EAGF;AACF;;AAAA;EACE,kBAAA;AAGF;AADE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAGJ;;AACA;EACE,eAAA;AAEF;AAAE;EAHF;IAII,eAAA;EAGF;AACF;AADE;EACE,gBAAA;EACA,eAAA;AAGJ;AADI;EAJF;IAKI,eAAA;EAIJ;AACF;;AAAA;EACE,kBAAA;AAGF;;AACE;EACE,cAAA;AAEJ;AACE;EACE,yBAAA;AACJ;;AAIE;EACE,cAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;;AAOE;EACE,cAAA;AAJJ;AAOE;EACE,yBAAA;AALJ;;AASA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AANF;;AASA;EACE,kBAAA;EACA,UAAA;AANF;AAQE;EAEE,UAAA;AAPJ;AASI;EAJF;IAKI,uBAAA;IACA,wBAAA;IACA,SAAA;IACA,YAAA;EANJ;AACF;AASE;EAhBF;IAiBI,YAAA;IACA,aAAA;EANF;AACF;;AASA;EACE,kBAAA;AANF;AAQE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AANJ;AAQI;EAbF;IAcI,SAAA;EALJ;AACF;AAOI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AALN;AAOM;EALF;IAMI,0BAAA;EAJN;AACF;AAOI;EACE,cAAA;AALN;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AARF;AAUE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AARJ;AAUI;EAbF;IAcI,SAAA;IACA,UAAA;EAPJ;AACF;AASI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAPN;AASM;EALF;IAMI,eAAA;EANN;AACF;AASI;EACE,cAAA;AAPN;;AAYA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,WAAA;EACA,QAAA;AAVF;AAYE;EAdF;IAeI,YAAA;IACA,aAAA;IACA,WAAA;EATF;AACF;AAWE;EACE,cAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AATJ;;AAcA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AAXF;AAaE;EALF;IAMI,gBAAA;EAVF;AACF;;AAaA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AAVF;AAYE;EAZF;IAaI,eAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;EATF;AACF;;AAYA;EACE,WAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AATF;;AAYA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;AATF;AAWE;EATF;IAUI,YAAA;IACA,aAAA;IACA,UAAA;IACA,WAAA;EARF;AACF;;AAWA;EACE,yDAAA;AARF;;AAWA;EACE,yDAAA;AARF","sourcesContent":[".wrapper {\n  background: linear-gradient(180deg, #ECFFFE 49.99%, #FFF 50%, #FFF 100%);\n\n  @media (max-width: 550px) {\n    padding: 22px 29px;\n  }\n}\n\n.title {\n  color: #242424;\n  font-size: 17px;\n  font-weight: 600;\n}\n\n.info_wrapper {\n  display: flex;\n  justify-content: space-between;\n  height: 73px;\n\n  .title {\n    color: #000000;\n    font-weight: 600;\n    font-size: 13px;\n  }\n\n  @media (max-width: 550px) {\n    flex-direction: column;\n    height: auto;\n  }\n}\n\n.availability_wrapper {\n  height: 100%;\n}\n\n.availability {\n  display: flex;\n  align-items: flex-end;\n  gap: 30px;\n  font-size: 12px;\n  color: #758282;\n\n  @media (max-width: 550px) {\n    gap: 15px\n  }\n}\n\n.availability_block {\n  position: relative;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 3.5px;\n    left: 0;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n  }\n}\n\n.availability_value {\n  font-size: 17px;\n\n  @media (max-width: 550px) {\n    font-size: 15px;\n  }\n\n  &__large {\n    font-weight: 600;\n    font-size: 27px;\n\n    @media (max-width: 550px) {\n      font-size: 20px;\n    }\n  }\n}\n\n.availability_period {\n  padding-left: 20px;\n}\n\n.availability_high {\n  .availability_value {\n    color: #00B86B;\n  }\n\n  &::before {\n    background-color: #00B86B;\n  }\n}\n\n.availability_medium {\n  .availability_value {\n    color: #FE974A;\n  }\n\n  &::before {\n    background-color: #FE974A;\n  }\n}\n\n.availability_low {\n  .availability_value {\n    color: #F44336;\n  }\n\n  &::before {\n    background-color: #F44336;\n  }\n}\n\n.monitors_wrapper {\n  display: flex;\n  align-items: center;\n  gap: 60px;\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.informer_icon {\n  position: relative;\n  z-index: 2;\n\n  &_problem {\n    @extend .informer_icon;\n    top: -10px;\n\n    @media (max-width: 550px) {\n      width: 120px !important;\n      height: 120px !important;\n      top: -5px;\n      right: -10px;\n    }\n  }\n\n  @media (max-width: 550px) {\n    width: 150px;\n    height: 150px;\n  }\n}\n\n.up {\n  position: relative;\n\n  &_info {\n    position: absolute;\n    top: 15px;\n    left: 15px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-left: 18px;\n    width: 136px;\n    height: 136px;\n    border-radius: 50%;\n    background-color: #FFFFFF;\n\n    @media (max-width: 550px) {\n      top: 10px\n    }\n\n    .counter {\n      font-weight: 600;\n      font-size: 37px;\n      color: #000000;\n\n      @media (max-width: 550px) {\n        font-size: 30px !important;\n      }\n    }\n\n    & > p {\n      color: #242424;\n    }\n  }\n}\n\n\n.has_problems {\n  position: absolute;\n  right: 68px;\n  top: 25%;\n\n  &_info {\n    position: absolute;\n    top: 10px;\n    left: 7px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-left: 20px;\n    width: 124px;\n    height: 124px;\n    border-radius: 50%;\n    background-color: #FFFFFF;\n\n    @media (max-width: 550px) {\n      top: -4px;\n      left: 15px;\n    }\n\n    .counter {\n      font-weight: 600;\n      font-size: 37px;\n      color: #F44336;\n\n      @media (max-width: 550px) {\n        font-size: 30px;\n      }\n    }\n\n    & > p {\n      color: #F44336;\n    }\n  }\n}\n\n.no_problems {\n  width: 130px;\n  height: 130px;\n  border-radius: 50%;\n  background-color: #FFFFFF;\n  border: solid 5px #758282;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  position: absolute;\n  right: 74px;\n  top: 25%;\n\n  @media (max-width: 550px) {\n    width: 114px;\n    height: 114px;\n    right: 64px;\n  }\n\n  & > p {\n    color: #758282;\n    font-family: Inter, sans-serif;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 17px;\n  }\n}\n\n\n.paused_wrapper {\n  position: relative;\n  height: 100%;\n  width: 120px;\n\n  @media (max-width: 550px) {\n    margin-top: 20px;\n  }\n}\n\n.paused_informer {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  border-radius: 30px;\n  background: #616E6E;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 11px 6px 6px;\n  gap: 6px;\n\n  @media (max-width: 550px) {\n    font-size: 20px;\n    left: 115px;\n    right: unset;\n    bottom: -10px;\n  }\n}\n\n.paused_value {\n  color: #FFF;\n  font-family: Inter, sans-serif;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 17px;\n}\n\n.problems_container {\n  width: 276px;\n  height: 276px;\n  position: absolute;\n  right: 0;\n  top: -56px;\n  display: flex;\n  z-index: 88;\n\n  @media(max-width: 550px) {\n    width: 240px;\n    height: 240px;\n    top: -40px;\n    right: -15%;\n  }\n}\n\n.problems_bg_green {\n  background-image: url(\"../../../images/problem_green.svg\");\n}\n\n.problems_bg_gray {\n  background-image: url(\"../../../images/problem_gray.svg\");\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SummaryMonitors_wrapper__oCK8X`,
	"title": `SummaryMonitors_title__ZBpF6`,
	"info_wrapper": `SummaryMonitors_info_wrapper__an4Hu`,
	"availability_wrapper": `SummaryMonitors_availability_wrapper__jG-n4`,
	"availability": `SummaryMonitors_availability__SbiVC`,
	"availability_block": `SummaryMonitors_availability_block__Z1LVx`,
	"availability_value": `SummaryMonitors_availability_value__4PMT3`,
	"availability_value__large": `SummaryMonitors_availability_value__large__xKfTI`,
	"availability_period": `SummaryMonitors_availability_period__oYfRB`,
	"availability_high": `SummaryMonitors_availability_high__QlHQD`,
	"availability_medium": `SummaryMonitors_availability_medium__oGnLn`,
	"availability_low": `SummaryMonitors_availability_low__24k4q`,
	"monitors_wrapper": `SummaryMonitors_monitors_wrapper__HikSE`,
	"informer_icon": `SummaryMonitors_informer_icon__9sirz`,
	"informer_icon_problem": `SummaryMonitors_informer_icon_problem__BCHQm`,
	"up": `SummaryMonitors_up__DNtFF`,
	"up_info": `SummaryMonitors_up_info__9WS+e`,
	"counter": `SummaryMonitors_counter__EEIqe`,
	"has_problems": `SummaryMonitors_has_problems__3JKqG`,
	"has_problems_info": `SummaryMonitors_has_problems_info__sG2Xr`,
	"no_problems": `SummaryMonitors_no_problems__UUjH1`,
	"paused_wrapper": `SummaryMonitors_paused_wrapper__46MHR`,
	"paused_informer": `SummaryMonitors_paused_informer__sdoFB`,
	"paused_value": `SummaryMonitors_paused_value__48uFz`,
	"problems_container": `SummaryMonitors_problems_container__5Sc9t`,
	"problems_bg_green": `SummaryMonitors_problems_bg_green__MLS0z`,
	"problems_bg_gray": `SummaryMonitors_problems_bg_gray__DJ3hS`
};
export default ___CSS_LOADER_EXPORT___;
